<template lang="html">

  <section class="faqs">
    <div class="container">
      <h1 class="title gray-text waypoints" data="fadeInUp">FAQs</h1>
      <section class="toggle-info waypoints" data="fadeInUp" v-for="(faq, key) in $t('faqs')" :key="key"
        @click="toggleContent(key)">
        <button type="button" class="toggle-button">
          <span v-if="activeContent[key]"> -</span>
          <span v-else>+</span>
        </button>
        <p class="title">
          {{ faq.title }}
        </p>
        <p class="description" v-if="activeContent[key]" v-html="faq.description"></p>
      </section>
    </div>
    <img src="/static/img/faqs-footer.png" alt="FAQs" class="faq-footer">
  </section>

</template>

<script lang="js">
export default {
  name: 'faqs',
  props: [],
  data() {
    return {
      activeContent: {}
    }
  },
  mounted() {
    const faqs = this.$t('faqs')

    Object.keys(faqs).forEach(key => {
      this.$set(this.activeContent, key, false)
    })
  },
  methods: {
    toggleContent(sectionKey) {
      this.$set(this.activeContent, sectionKey, !this.activeContent[sectionKey])
    }
  },
}
</script>

<style scoped lang="scss">
.faqs {
  background: url('../../../static/img/bg-politicas.svg');
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 100px 0 400px;
  text-align: left;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 100px 0;
  }

  .faq-footer {
    width: 100%;
    position: absolute;
    bottom: -10px;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 0.7;
    max-width: 100%;
  }

  h1 {
    margin-bottom: 20px;
    max-width: 200px;
    font-size: 8vw;
    line-height: 1em;

    @media screen and (max-width:900px) {
      font-size: 15vw;
    }
  }

  .toggle-info {
    cursor: pointer;
    padding: 10px 55px 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    position: relative;

    @media screen and (max-width: 600px) {
      padding: 25px 0px 25px 0;
    }

    &:first-of-type {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .toggle-button {
      position: absolute;
      right: 0;
      bottom: 0;
      top: 0;
      cursor: pointer;
      background: transparent;
      border: 0;
      z-index: 4;
      @media screen and (max-width: 1100px) {
        bottom: initial;
        top: 0px;
      }
      @media screen and (max-width: 600px) {
        top: 15px;
      }

      span {
        font-size: 40px;
        font-weight: bold;
        font-family: 'Futura Md BT Bold';
        padding: 10px;

        @media screen and (max-width: 600px) {
          font-size: 30px;
        }
      }
    }

    .title {
      font-size: 24px;
      font-weight: bold;

      @media screen and (max-width:600px) {
        font-size: 18px;
        line-height: 1em;
        padding-right: 34px;
      }
    }

    .description {
      font-size: 18px;

      @media screen and (max-width:600px) {
        margin-top: 10px;
      }
    }
  }

  .container {
    @media screen and(max-width:1470px) {
      width: 100%;
      padding: 0 8vw !important;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/faqs.vue